import type { CSSObject } from '@emotion/react'
import type { FC, ReactNode } from 'react'
import { SharedSettings } from 'settings/SharedSettings'
import { layersNavigationMenuStore } from 'stores/layersNavigationMenuStore/layersNavigationMenuStore'

const { SPACING_WHEN_MENU_COLLAPSED, SPACING_WHEN_MENU_OPEN } =
  SharedSettings.SPACING_FOR_THINGS_THAT_FLOAT_OVER_LEFT_SIDE_OF_MAP

export const WideScreenSearch: FC<{ children: ReactNode }> = (props) => {
  const menuCollapsed = layersNavigationMenuStore.useSelector((s) => s.menuCollapsed)

  const wideScreenContainerStyles: CSSObject = {
    position: 'fixed',
    margin:
      'env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)',
    top: menuCollapsed ? 77 : 5,
    left: menuCollapsed ? SPACING_WHEN_MENU_COLLAPSED : SPACING_WHEN_MENU_OPEN,
  }

  return <div css={wideScreenContainerStyles}>{props.children}</div>
}
